import React, { useState, useEffect } from "react";
import {
  SetWithdrawalPinButton,
  SetWithdrawalPinCard,
  SetWithdrawalPinContainer,
  SetWithdrawalPinInput,
} from "./SetWithdrawalPin.styled";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { setWithdrawalPin } from "../../feature/withdraw/WithdrawActions";
import { FormError, FormWrapper } from "../Auth.styled";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import ReactLoading from "react-loading";
import SuccessPage from "../SuccessPage/SuccessPage";

const SetWithdrawalPin = () => {
  const dispatch = useDispatch();
  const [saved, setSaved] = useState(false);

  const { inputError } = useSelector((state) => state.inputError);
  const { loading } = useSelector((state) => state.withdraw);

  const initialValues = {
    pin: "",
    confirm_pin: "",
    password: "",
  };

  const onSubmit = (values) => {
    dispatch(
      setWithdrawalPin({ user: 1, pin: values.pin, password: values.password })
    )
      .unwrap()
      .then((res) => setSaved(true));
  };

  const validationSchema = Yup.object({
    pin: Yup.string()
      .min(5, `Pin must be 5`)
      .max(5, `Pin must be 5 digits`)
      .required("Pin is required"),
    confirm_pin: Yup.string()
      .min(5, ``)
      .max(5, ``)
      .required("Confirm Pin is required")
      .oneOf([Yup.ref("pin"), null], "Pin Must Match"),
    password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  useEffect(() => {
    dispatch(clearInputError());
  }, [dispatch]);

  return (
    <SetWithdrawalPinContainer>
      {saved ? (
        <SuccessPage
          message="Withdrawal Pin Saved"
          links={[{ link: "/withdrawal", name: "Withdrawal" }]}
        />
      ) : (
        <SetWithdrawalPinCard onSubmit={formik.handleSubmit}>
          <FormWrapper>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginInlineEnd: "-20px" }}
            >
              <path
                d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.5"
                d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
                fill="white"
              />
            </svg>
            <SetWithdrawalPinInput
              type="text"
              name="pin"
              pattern="\d*"
              placeholder="New Pin"
              onChange={formik.handleChange}
              value={formik.values.pin}
            />
          </FormWrapper>
          <>
            {formik.errors.pin ? (
              <FormError>{formik.errors.pin}</FormError>
            ) : null}
          </>
          <FormWrapper>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginInlineEnd: "-20px" }}
            >
              <path
                d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.5"
                d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
                fill="white"
              />
            </svg>
            <SetWithdrawalPinInput
              type="text"
              name="confirm_pin"
              pattern="\d*"
              placeholder="Confirm Pin"
              onChange={formik.handleChange}
              value={formik.values.confirm_pin}
            />
          </FormWrapper>
          <>
            {formik.errors.confirm_pin ? (
              <FormError>{formik.errors.confirm_pin}</FormError>
            ) : null}
          </>
          <FormWrapper>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginInlineEnd: "-20px" }}
            >
              <path
                d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.5"
                d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
                fill="white"
              />
            </svg>
            <SetWithdrawalPinInput
              type="password"
              name="password"
              placeholder="Password"
              onChange={formik.handleChange}
              value={formik.values.password}
            />
          </FormWrapper>
          <>
            {formik.errors.password ? (
              <FormError>{formik.errors.password}</FormError>
            ) : null}
            <FormError>
              {inputError !== undefined
                ? inputError.password
                  ? inputError.password
                  : null
                : null}
            </FormError>
          </>
          <SetWithdrawalPinButton type="submit" disabled={loading}>
            {loading ? (
              <ReactLoading
                type={"spinningBubbles"}
                height={"20px"}
                width={"20px"}
              />
            ) : (
              "Save"
            )}
          </SetWithdrawalPinButton>
        </SetWithdrawalPinCard>
      )}
    </SetWithdrawalPinContainer>
  );
};

export default SetWithdrawalPin;
